import Temp from "@/courier/Temp";

export default class Ninjavan extends Temp {
  static CODE = "NJV";

  constructor() {
    super(Ninjavan.CODE);
  }

  getZone(item) {
    let type;
    let cross_price = 0;
    let remote_area = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    type = super.checkZone(item.toPostcode);

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });
    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getRemoteArea(addressRemote).then((res) => {
        if (
          res.status === 1 &&
          (res.data.hasOwnProperty("isRemote") ||
            res.data.hasOwnProperty("isRemote100")) &&
          res.data.isRemote.includes("ninjavan")
        ) {
          resolve(true);
        } else if (res.status === 0 && res.data.length === 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }
}
